class SearchFilterString {
  constructor(
    public id: string,
    public name: string,
    public search_results_no?: number | undefined
  ) {}
}

export default SearchFilterString;
